import { Location, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AccountFacade } from 'ish-core/facades/account.facade';

@Component({
  selector: 'ish-azure-sign-in',
  templateUrl: './azure-sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslateModule, NgClass],
})
export class AzureSignInComponent {
  private location = inject(Location);
  private router = inject(Router);
  private accountFacade = inject(AccountFacade);
  @Input() isModal = false;

  readonly signInClass = input<string>(undefined);

  get returnUrl() {
    return this.location.path();
  }

  login() {
    this.accountFacade.setIdentityProvider('Azure');
    // Wait until the factory has initialized the provider
    setTimeout(() => {
      this.router.navigate(['/loginWithAzure'], {
        queryParams: { returnUrl: this.returnUrl },
      });
    }, 100); // Small delay (~100ms) gives store time to propagate
  }
}
